import PriorityHighRoundedIcon from "@mui/icons-material/PriorityHighRounded";
import SellRoundedIcon from "@mui/icons-material/SellRounded";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { colors } from "@components/ui/colors";
import { CARD_STYLES } from "./ScopeOfWorkTypeOfService";
import { SECTION_STYLES } from "@components/jobs/jobs-list/jobs-layout/components/Summary/JobScopeOfWorkView";

export const ScopeOfWorkSpecialRequests = ({ list = [] }) => {
  if (!list.length) return null;

  return (
    <Box sx={SECTION_STYLES.root}>
      <SectionHeader title="Special requests" count={list.length} icon={<PriorityHighRoundedIcon sx={{ fontSize: 20 }} />} />

      <Grid container spacing={1.5}>
        {list.map((item) => {
          const req = item.specialRequest ?? item.request ?? item;
          const requestName = req.name ?? req.uid ?? "Unnamed request";
          const imageUrl = req.imageUrl ?? req.image?.url ?? req.iconUrl ?? null;
          const hasNotes = Boolean(req.description?.trim());
          const appliedToNames = req.specialRequestsByServices?.map((srv) => srv.typeOfService?.name).filter(Boolean) || [];

          return (
            <Grid item xs={12} sm={6} md={4} key={req.uid ?? item.uid ?? requestName}>
              <Box sx={SECTION_STYLES.imageCard}>
                <Box sx={SECTION_STYLES.imageBox}>
                  {imageUrl ? (
                    <Box
                      component="img"
                      src={imageUrl}
                      alt={requestName}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <PriorityHighRoundedIcon sx={{ fontSize: 34 }} />
                  )}
                </Box>

                <Box sx={{ mt: 1.25, minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      fontWeight: 900,
                      color: colors.gray[800],
                      lineHeight: 1.25,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={requestName}
                  >
                    {requestName}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

function SectionHeader({ title, count, icon }: { title: string; count: number; icon: React.ReactNode }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mb: 1.5 }}>
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Box sx={SECTION_STYLES.iconBox}>{icon}</Box>

        <Box>
          <Typography sx={CARD_STYLES.sectionLabel}>{title}</Typography>
        </Box>
      </Stack>

      <Box sx={SECTION_STYLES.pill}>{count} selected</Box>
    </Stack>
  );
}
